import React from 'react';
import { useIntersectionObserver } from './hooks/useIntersectionObserver';

const LazySection = ({ 
  children, 
  className = '', 
  animationType = 'fade',
  delay = 0 
}) => {
  const { elementRef, isVisible } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.1,
  });

  const getAnimationClasses = () => {
    const baseClasses = 'transition-all duration-1000 ease-out';
    
    switch (animationType) {
      case 'slide':
        return `${baseClasses} ${
          isVisible 
            ? 'translate-y-0 opacity-100' 
            : 'translate-y-16 opacity-0'
        }`;
      case 'zoom':
        return `${baseClasses} ${
          isVisible 
            ? 'scale-100 opacity-100' 
            : 'scale-95 opacity-0'
        }`;
      case 'parallax':
        return `${baseClasses} ${
          isVisible 
            ? 'translate-y-0 opacity-100' 
            : 'translate-y-8 opacity-0'
        }`;
      default:
        return `${baseClasses} ${
          isVisible 
            ? 'opacity-100' 
            : 'opacity-0'
        }`;
    }
  };

  return (
    <div 
      ref={elementRef}
      className={`${getAnimationClasses()} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default LazySection;
